import { handleAjaxError } from "./handleAjaxError";

/**
 * @param message
 * @param chatForm
 */
export function deleteMessage(action) {
    // Message actions are initialized after every dynamic render. A delegated,
    // namespaced listener keeps exactly one Delete request per click.
    $(document)
        .off('click.growtypeChatDeleteMessage', '.g-chatform:not(.g-chatform-pinned) .g-chatform-message-delete')
        .on('click.growtypeChatDeleteMessage', '.g-chatform:not(.g-chatform-pinned) .g-chatform-message-delete', function (event) {
        event.preventDefault();

        let submitBtn = $(this);
        let chatForm = submitBtn.closest('.g-chatform');
        let sessionToken = chatForm.attr('data-session-token');
        let messageElement = submitBtn.closest('.g-chatform-message');
        let messageId = messageElement.attr('data-id');

        if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
            return;
        }

        if (!messageId) {
            messageElement.fadeOut(200, function () {
                messageElement.remove();
            });
            return;
        }

        if (!sessionToken) {
            submitBtn.addClass('is-disabled');
            return;
        }

        submitBtn.addClass('is-loading');

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                token: sessionToken,
                action: growtype_chat_ajax.delete_message_action,
                message_id: messageId,
                nonce: growtype_chat_ajax.nonce,
            }, success: function (response) {
                submitBtn.removeClass('is-loading');
                if (response.success) {
                    messageElement.fadeOut(200, function () {
                        messageElement.remove();
                    });
                } else {
                    handleAjaxError(response, submitBtn);
                }
            }, error: function (response) {
                submitBtn.removeClass('is-loading');
                handleAjaxError(response, submitBtn);
            }
        });
    });
}
